import { render } from "./AllPhysicians.vue?vue&type=template&id=01151018"
import script from "./AllPhysicians.vue?vue&type=script&lang=js"
export * from "./AllPhysicians.vue?vue&type=script&lang=js"

import "./AllPhysicians.vue?vue&type=style&index=0&id=01151018&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/physicians/AllPhysicians.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01151018"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01151018', __exports__)) {
    console.log('reload')
    api.reload('01151018', __exports__)
  }
  
  module.hot.accept("./AllPhysicians.vue?vue&type=template&id=01151018", () => {
    console.log('re-render')
    api.rerender('01151018', render)
  })

}


export default __exports__